<template>
	<div id="sre-function">
		<h2>功能介绍</h2>
		<p>维图云管平台为客户提供跨云统一管理、自动化运维、自服务以及服务流程管理等功能。</p>
		<ul class="list">
			<li class="item" :class="{'active':active==1}" @mouseenter="activeMe(1)">
				<i class="iconfont icon-yun1" />
				<h4>云管理</h4>
				<h4 style="margin-bottom: 37px;">（CloudManagement）</h4>
				<p>
					异构资源统一管理，例如主机的重启、
					访问等；
				</p>
				<p>
					自服务，开发者在管理员提供的服务
					目录中一键申请并获得资源或服务；
				</p>
				<p>
					成本中心，使云成本开支一目了然，
					基于自定义的成本监控策略及时提供成本优化建议；
				</p>
			</li>
			<li class="item" :class="{'active':active==2}" @mouseenter="activeMe(2)">
				<i class="iconfont icon-zidonghua" />
				<h4>自动化</h4>
				<h4 style="margin-bottom: 37px;">（Automation）</h4>
				<p>
					事件驱动的自动化运维工具；
				</p>
				<p>
					规范运维操作，使日常操作工具化；
				</p>
				<p>
					作业流程编排支持更多运维场景；
				</p>
			</li>
			<li class="item" :class="{'active':active==3}" @mouseenter="activeMe(3)">
				<i class="iconfont icon-jiankong" />
				<h4>监控</h4>
				<h4 style="margin-bottom: 37px;">（Monitor）</h4>
				<p>
					多云环境的统一监控，通过调用公有
					云API以及Agent采集方式实现监控范
					围的全覆盖；
				</p>
				<p>
					灵活设置告警规则，支持邮件、微信
					等多种告警提醒方式
				</p>
			</li>
			<li class="item" :class="{'active':active==4}" @mouseenter="activeMe(4)">
				<i class="iconfont icon-Icon-liuchengzhikong" />
				<h4>服务流程</h4>
				<h4 style="margin-bottom: 37px;">（ITSM）</h4>
				<p>提供敏捷的流程建模能力；
				</p>
				<p>自定义表单；
				</p>
				<p>支持超时督办，灵活处理工单；</p>
			</li>
			<li class="item" :class="{'active':active==5}" @mouseenter="activeMe(5)">
				<i class="iconfont icon-zhandianpeizhi" />
				<h4>配置管理</h4>
				<h4 style="margin-bottom: 37px;">（CMDB）</h4>
				<p>
					统一的配置管理数据源，自定义资源模型、自动发现更新配置。
				</p>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'SreFunction',
		data() {
			return {
				active: 1
			}
		},
		methods: {
			activeMe(index) {
				this.active = index
			}
		}
	}
</script>

<style>
	@media(min-width:992px) {
		#sre-function {
			width: 100%;
			height: 745px;
			background-color: rgba(224, 237, 255, 0.6);
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
		}

		#sre-function h2 {
			font-size: 36px;
			font-family: SimHei;
			font-weight: bold;
			color: rgba(51, 51, 51, 1);
			margin-top: 79px;
		}

		#sre-function p {
			font-size: 18px;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(68, 68, 68, 1);
			margin: 37px 0 69px;
		}

		#sre-function ul {
			display: flex;
			justify-content: space-between;
			width: 78%;
			height: 428px;
		}

		#sre-function ul li {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			width: 18.5%;
			height: 100%;
			background-color: rgba(242, 249, 255, 1);
			border-radius: 4px;
			transition: .6s;
			-moz-transition: .6s;
			-webkit-transition: .6s;
			-moz-transition: .6s;
		}

		#sre-function ul li.active {
			background-color: #043F6A;
		}

		#sre-function ul li i {
			display: block;
			margin: 50px 0 20px;
			height: 52px;
			font-size: 55px;
			color: #00D5DF;
		}

		#sre-function ul li.active i {
			background: linear-gradient(0deg, rgba(3, 208, 217, 1), rgba(0, 244, 255, 1));
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}

		#sre-function ul li h4 {
			text-align: center;
			font-size: 16px;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
			line-height: 23px;
		}

		#sre-function ul li.active h4 {
			color: #00EBF6;
		}

		#sre-function ul li p {
			font-size: 12px;
			font-family: SimSun;
			font-weight: 400;
			color: rgba(51, 51, 51, .8);
			line-height: 20px;
			text-align: left;
			width: 74%;
			margin: 0 36px;
			margin-bottom: 29px;
		}

		#sre-function ul li.active p {
			color: rgba(157, 221, 224, 1);
		}
	}

	/* 移动端 */
	@media(max-width:992px) {
		#sre-function {
			width: 100%;
			background-color: rgba(224, 237, 255, 0.6);
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
		}

		#sre-function h2 {
			font-size: 0.2rem;
			font-family: SimHei;
			font-weight: bold;
			color: rgba(51, 51, 51, 1);
			margin-top: 35px;
		}

		#sre-function p {
			width: 90%;
			font-size: 0.12rem;
			font-family: SimHei;
			line-height: 1.1;
			font-weight: 400;
			color: rgba(68, 68, 68, 1);
			margin: 0.37rem 0 0.69rem;
		}

		#sre-function ul {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			width: 100%;
		}

		#sre-function ul li {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			width: 90%;
			background-color: rgba(242, 249, 255, 1);
			border-radius: 4px;
			margin-bottom: 10px;
		}

		#sre-function ul li i {
			display: block;
			margin: 10px 0;
			font-size: 0.25rem;
			color: #00D5DF;
		}

		#sre-function ul li h4 {
			text-align: center;
			font-size: 0.14rem;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
		}

		#sre-function ul li p {
			font-size: 0.12rem;
			font-family: SimSun;
			font-weight: 400;
			color: rgba(51, 51, 51, .8);
			line-height: 1.1;
			text-align: left;
			width: 80%;
			margin: 0 10px;
			margin-bottom: 10px;
		}

		/* #sre-function ul li.active p {
			color: rgba(157, 221, 224, 1);
		} */
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/SreFunction.vue